/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export enum TemplateType {
	task = 'task',
	milestone = 'milestone',
	constraint = 'constraint',
	multiTask = 'multiTask',
	multiMilestone = 'multiMilestone',
	multiConstraint = 'multiConstraint',
	customAttribute = 'customAttribute', //as a reminder for later
}
